import React from "react";
import styled from "styled-components";
import { HashLink } from "react-router-hash-link";

const Root = styled.div`
  width: fit-content;
  font-size: 1.5rem;
  letter-spacing: 0.75px;
  font-weight: ${props => props.theme.fontWeight.regular};
  color: ${props => props.theme.colors.primary.white};
  text-transform: uppercase;
  cursor: pointer;
`;

export const FooterMenuItem = ({ label, targetId }) => {
  return (
    <Root>
      {
        targetId.indexOf("http") >= 0
          ? <a href={targetId} target="_blank" rel="noreferrer">{label}</a>
          : <HashLink to={`${targetId}`} smooth>{label}</HashLink>
      }
    </Root>
  );
};
